// src/hooks/useWindowWidth.js
// The window's width, kept up to date (3.20.1: phone and tablet layouts)
import { useEffect, useState } from 'react';

export const PHONE = 760;   // below this: phone layout (3.51.0: slim header, bottom bar, cards)
// 3.51.0 (owner): a phone turned sideways (~844 × 390) keeps the phone
// layout: a touch screen less than this tall counts as a phone too.
// Tablets (768 px and wider, taller than this) keep the computer layout.
export const SHORT = 500;
// The same rule for CSS: @media ${PHONE_MEDIA} { … }
export const PHONE_MEDIA = `(max-width: ${PHONE - 1}px), (pointer: coarse) and (max-height: ${SHORT - 1}px)`;

export default function useWindowWidth() {
  const [w, setW] = useState(() => (typeof window !== 'undefined' ? window.innerWidth : 1200));
  useEffect(() => {
    const on = () => setW(window.innerWidth);
    window.addEventListener('resize', on);
    return () => window.removeEventListener('resize', on);
  }, []);
  return w;
}

// Phone layout or not (3.51.0): narrower than PHONE, or a short touch screen
const isPhone = () => typeof window !== 'undefined' && !!window.matchMedia?.(PHONE_MEDIA).matches;
export function usePhone() {
  const [phone, setPhone] = useState(isPhone);
  useEffect(() => {
    const on = () => setPhone(isPhone());
    window.addEventListener('resize', on);
    window.addEventListener('orientationchange', on);
    return () => { window.removeEventListener('resize', on); window.removeEventListener('orientationchange', on); };
  }, []);
  return phone;
}
